

exports.__esModule = true;
exports.formatReturnContent = exports.MAX_MERCHANT_NAME_LENGTH = exports.$ReturnToMerchant = void 0;
var _util = require("./util");
exports.$ReturnToMerchant = _util.$ReturnToMerchant;
var _formatReturnContent = require("./formatReturnContent");
exports.formatReturnContent = _formatReturnContent.formatReturnContent;
exports.MAX_MERCHANT_NAME_LENGTH = _formatReturnContent.MAX_MERCHANT_NAME_LENGTH;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-return-to-merchant/dist/index.js
// module id = ../node_modules/xo-return-to-merchant/dist/index.js
// module chunks = 0